module.exports = __webpack_public_path__ + "img/advocates_for_youth_logo.9674be34.png";